import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { BaseApiService } from './base-api.service';
import { Message, SendMessageRequest, SendMessageWithAttachmentsRequest } from '../models/message';
import { environment } from '../../../environments/environment';
import { PagingOptions } from '../models/paged-options';
import { MessageDocument } from '../models/message-document';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MessageService extends BaseApiService<Message> {

  constructor(httpClient: HttpClient) {
    super(httpClient, `${environment.apiUrl}/messages`);
  }

  getMessages(fromClient: boolean, pagingOptions: PagingOptions) {
    return this.getPagedList<Message>(pagingOptions, undefined, { fromClient });
  }

  getMessage(messageId: string) {
    return this.get(messageId);
  }

  getMessageAttachments(messageId: string) {
    return this.httpClient.get<MessageDocument[]>(`${this.baseApiUrl}/${messageId}/Attachments`);
  }

  downloadMessageAttachment(messageId: string, attachmentId: string) {
    return this.httpClient.get(`${this.baseApiUrl}/${messageId}/Attachments/${attachmentId}/Download`, { responseType: 'arraybuffer', observe: 'response'});
  }

  search(searchText: string, hasAttachments: boolean | undefined, isUnread: boolean | undefined, hasUnreadAttachments: boolean | undefined, searchSubject: boolean, searchBody: boolean, pagingOptions: PagingOptions, fromClient: boolean) {
    return this.getPagedList(pagingOptions, this.baseApiUrl + '/Search', { searchText, hasAttachments, isUnread, hasUnreadAttachments, searchSubject, searchBody, fromClient });
  }

  sendMessage(messageRequest: SendMessageRequest) {
    return this.create(messageRequest, `${this.baseApiUrl}/Client`);
  }

  sendMessageWithAttachments(messageRequest: SendMessageWithAttachmentsRequest) {
    return this.httpClient.post(`${this.baseApiUrl}/ClientAttachments`, messageRequest);
  }

  readMessage(messageId: string) {
    return this.httpClient.post(`${this.baseApiUrl}/${messageId}/Read`, null);
  }

  getUnreadCount() {
    return this.httpClient.get<number>(`${this.baseApiUrl}/unreadCount`);
  }

  deleteAttachments(ids: string[]): Observable<any> {
    return this.httpClient.post('/api/attachments/delete', { ids });
  }

}
